import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/api";

export default function IndividualClientDeletePage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [client, setClient] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        loadClient();
    }, [id]);

    const loadClient = async () => {
        try {
            const { data } = await api.get(`/Client/${id}`);
            setClient(data);
        } catch (err) {
            setError(err?.response?.data?.message || "Failed to load client.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setDeleting(true);
            await api.delete(`/Client/delete/${id}`);
            navigate("/admin/individual-clients");
        } catch (err) {
            setError(err?.response?.data?.message || "Failed to delete client.");
        } finally {
            setDeleting(false);
        }
    };

    if (loading) return <p>Loading client...</p>;
    if (error) return <p className="text-red-600">{error}</p>;
    if (!client) return <p>Client not found.</p>;

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-2xl font-bold mb-4">Delete Individual Client</h1>

            <p className="mb-4">
                Are you sure you want to delete client{" "}
                <strong>{client.name} {client.lastName}</strong>?
            </p>

            <div className="flex gap-3">
                <button
                    onClick={handleDelete}
                    disabled={deleting}
                    className="bg-red-600 text-white px-4 py-2 rounded"
                >
                    {deleting ? "Deleting..." : "Delete"}
                </button>

                <button
                    onClick={() => navigate("/admin/individual-clients")}
                    className="border px-4 py-2 rounded"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}